export default __webpack_public_path__ + "static/media/whoWillSeeResults_xl_woman.bcaf64a0.png";